export default __webpack_public_path__ + "static/media/watermark.641383d5.jpeg";